import { Check } from 'lucide-react'
import { useMarkEngagedTopicDone, type EngagedTopic } from '../lib/api'

export default function EngagedTopicDoneButton({ topic }: { topic: EngagedTopic }) {
  const done = useMarkEngagedTopicDone()
  return (
    <div className="mr-2 max-w-28 shrink-0">
      <button
        type="button"
        aria-label={`Mark ${topic.title || 'Untitled topic'} done for now`}
        title="Hide from this list until you reply to this topic again. The topic stays open."
        disabled={done.isPending || !topic.participation_message_id}
        onClick={() => done.mutate(topic)}
        className="inline-flex min-h-11 min-w-11 items-center justify-center gap-1 rounded-lg px-2 text-xs text-emerald-700 hover:bg-emerald-50 disabled:opacity-50 dark:text-emerald-400 dark:hover:bg-emerald-950/40"
      >
        <Check className="h-4 w-4" aria-hidden />
        {done.isPending ? 'Saving…' : 'Done'}
      </button>
      {done.isError && <p role="alert" className="pb-2 text-xs text-red-600 dark:text-red-400">
        Could not save. Tap Done to retry.
      </p>}
    </div>
  )
}
